/*
  =====================================================================
  EVOA Pet Supplement – Variant Selector JS
  File:   assets/evoa-variant-selector.js

  Add to theme.liquid before </body>:
    {{ 'evoa-variant-selector.js' | asset_url | script_tag }}
  =====================================================================
*/

/**
 * Select a variant card and sync the hidden form input + price display.
 * @param {HTMLElement} el – the clicked .evoa-variant-card
 */
function evoaSelectVariant(el) {
  const productId = el.dataset.productId;

  // Deselect siblings
  document
    .querySelectorAll(`.evoa-variant-card[data-product-id="${productId}"]`)
    .forEach(c => {
    c.classList.remove('selected');
    c.setAttribute('aria-checked', 'false');
  });

  // Select this card
  el.classList.add('selected');
  el.setAttribute('aria-checked', 'true');

  // Sync hidden variant input
  const variantId = el.dataset.variantId;
  const input = document.getElementById(`evoa-variant-input-${productId}`);
  if (input) input.value = variantId;

  // Update displayed price
  const price   = parseInt(el.dataset.price,   10);   // in cents
  const compare = parseInt(el.dataset.compare, 10);

  const nowEl    = document.getElementById(`evoa-price-now-${productId}`);
  const wasEl    = document.getElementById(`evoa-price-was-${productId}`);
  const badgeEl  = document.getElementById(`evoa-save-badge-${productId}`);

  if (nowEl) nowEl.textContent = evoaFormatMoney(price);

  if (wasEl) {
    if (compare && compare > price) {
      wasEl.textContent = evoaFormatMoney(compare);
      wasEl.style.display = '';
    } else {
      wasEl.textContent = '';
      wasEl.style.display = 'none';
    }
  }

  if (badgeEl) {
    if (compare && compare > price) {
      const pct = Math.round((compare - price) / compare * 100);
      badgeEl.textContent = `SAVE ${pct}%`;
      badgeEl.style.display = '';
    } else {
      badgeEl.style.display = 'none';
    }
  }
}

/**
 * Format Shopify price (cents) to RM display string.
 * Adjust currency symbol / format to match your store settings.
 */
function evoaFormatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents, '{{ amount }}');
  }
  return 'RM' + (cents / 100).toFixed(2);
}

/**
 * Ripple effect on ATC button click.
 * @param {MouseEvent} e
 * @param {HTMLElement} btn
 */
function evoaRipple(e, btn) {
  const circle   = document.createElement('span');
  const diameter = Math.max(btn.clientWidth, btn.clientHeight);
  const radius   = diameter / 2;
  const rect     = btn.getBoundingClientRect();

  circle.style.width  = diameter + 'px';
  circle.style.height = diameter + 'px';
  circle.style.left   = (e.clientX - rect.left  - radius) + 'px';
  circle.style.top    = (e.clientY - rect.top   - radius) + 'px';
  circle.classList.add('evoa-ripple');

  const old = btn.querySelector('.evoa-ripple');
  if (old) old.remove();
  btn.appendChild(circle);
}